import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, message } from 'antd'
import { updateInspection, resetUpdateInspection } from '../../../store/reducers/inspection/inspectionSlice'
import {
  selectInspectionsData,
  selectInspectionSubmissionsData,
  selectUpdateInspectionStatus,
  selectUpdateInspectionError,
} from '../../../store/reducers/inspection/inspectionSelectors'
import STATUS from '../../../common/constants/reducer_statuses'
import CompleteDataCollectionModal from './CompleteDataCollectionModal'

const DATA_COLLECTION_COMPLETE_STATUS = 'data_collection_complete'

const CompleteDataCollectionButton = ({ refreshOrder }) => {
  const dispatch = useDispatch()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const inspectionsData = useSelector(selectInspectionsData)
  const inspectionSubmissionsData = useSelector(selectInspectionSubmissionsData)
  const updateInspectionStatus = useSelector(selectUpdateInspectionStatus)
  const updateInspectionError = useSelector(selectUpdateInspectionError)

  const inspection = inspectionsData?.[0]
  const inspectionId = inspection?._id
  const backofficeStatus = inspection?.backoffice_status

  const isAlreadyComplete = backofficeStatus === DATA_COLLECTION_COMPLETE_STATUS
  const isLoading = updateInspectionStatus === STATUS.LOADING

  useEffect(() => {
    dispatch(resetUpdateInspection())
  }, [dispatch])

  useEffect(() => {
    if (updateInspectionStatus === STATUS.SUCCEEDED) {
      message.success('Data collection completed successfully.')
      setIsModalVisible(false)
      if (refreshOrder) {
        refreshOrder()
      }
    }
  }, [updateInspectionStatus, refreshOrder])

  useEffect(() => {
    if (updateInspectionStatus === STATUS.FAILED && updateInspectionError) {
      const errorMessage =
        typeof updateInspectionError === 'string'
          ? updateInspectionError
          : 'Failed to complete data collection. Please try again.'
      message.error(errorMessage)
    }
  }, [updateInspectionStatus, updateInspectionError])

  const handleOpenModal = () => {
    setIsModalVisible(true)
  }

  const handleCloseModal = () => {
    setIsModalVisible(false)
  }

  const handleCompleteDataCollection = () => {
    if (isLoading || !inspectionId) {
      return
    }

    dispatch(updateInspection({
      inspectionId,
      update: { backoffice_status: DATA_COLLECTION_COMPLETE_STATUS },
      publishEvent: true,
    }))
  }

  return (
    <>
      <Button
        type="primary"
        onClick={handleOpenModal}
        disabled={isAlreadyComplete || !inspectionId}
        data-testid="complete-data-collection-button"
      >
        Complete Data Collection
      </Button>
      <CompleteDataCollectionModal
        visible={isModalVisible}
        onCancel={handleCloseModal}
        onContinue={handleCompleteDataCollection}
        inspectionSubmissionsData={inspectionSubmissionsData}
        isLoading={isLoading}
      />
    </>
  )
}

export default CompleteDataCollectionButton
